import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerDescription, DrawerBody } from "@/components/ui/drawer";
import type { Booking } from "@/types/Booking";
import { CancelBookingDialogProvider } from "./CancelBookingDialogProvider";
import { useCancelBookingDialog } from "./useCancelBookingDialog";
import { WarnScreen } from "./screens/WarnScreen";
import { FromDateScreen } from "./screens/FromDateScreen";
import { ConfirmScreen } from "./screens/ConfirmScreen";
import { ResultScreen } from "./screens/ResultScreen";
import { SlotRestrictionScreen } from "./screens/SlotRestrictionScreen";

const Content = () => {
  const { currentScreen } = useCancelBookingDialog();
  switch (currentScreen) {
    case "warn": return <WarnScreen />;
    case "from-date": return <FromDateScreen />;
    case "confirm": return <ConfirmScreen />;
    case "result": return <ResultScreen />;
    case "slot-restricted": return <SlotRestrictionScreen />;
    default: return <WarnScreen />;
  }
};

export const CancelBookingDialog = ({
  booking,
  open,
  onOpenChange,
}: {
  booking: Booking | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) => {
  if (!booking) return null;
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent>
        <DrawerHeader className="sr-only">
          <DrawerTitle>Cancel booking</DrawerTitle>
          <DrawerDescription>Review the cancellation details and confirm.</DrawerDescription>
        </DrawerHeader>
        <DrawerBody>
          <CancelBookingDialogProvider key={booking.id} booking={booking} onClose={() => onOpenChange(false)}>
            <Content />
          </CancelBookingDialogProvider>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
